import * as tslib_1 from "tslib";
import { orchestrator } from 'satcheljs';
import { manageSecurity } from '../actions/manageSecurity';
import { logUsage } from 'owa-analytics';
import datapoints from '../datapoints';
var manageSecurityUrl = 'https://go.microsoft.com/fwlink/?linkid=872493';
export default orchestrator(manageSecurity, function manageSecurity() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            logUsage(datapoints.PremiumDashSecurityManage.datapoint.name);
            window.open(manageSecurityUrl, '_blank');
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=manageSecurity.js.map